import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import { Outlet, useLocation } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import axios from "../../utils/axiosInstance"; 
import { useNavigate } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import { Box, ActionIcon, Tooltip } from "@mantine/core";
import { IconDownload, IconEye } from "@tabler/icons-react";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import Pagination from "rc-pagination";
import { CircularProgress, debounce } from "@material-ui/core";
const useStyles = makeStyles(styles);
export default function WinnerLogs() {

  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [paginationData, setPaginationData] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalItems: 0,
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const lotteryData = users?.data;
  const classes = useStyles();
  const navigate = useNavigate();
  const [formValues, setFormValues] = React.useState({
    lotteryName: "",
    ticketPrice: 0,
    numOfTicketOnSale: 0,
    ticketCountdown: 0,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    lotteryDrawDate: "",
    lotteryDrawTime: "",
    totalDraw: 0,
    firstDrawPrize: 0,
    secondDrawPrize: 0,
    thirdDrawPrize: 0,
    instruction: "",
    maxRpmLotteryWheel: 0,
    decelarationOfLotteryWheel: 20,
    maxNumOfTickets: 0,
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const isViewing = location.pathname.includes("winnerLogsById");
  console.log(formValues, "formValues");
  const columns = useMemo(() => [
    {
      accessorFn: () => "image",
      id: "Image",
      header: "Lottery Image",
      size: 100,
      Cell: ({ row }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <img
            alt="avatar"
            height={30}
            src={`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${row.original.image}`}
            style={{ borderRadius: "50%" }}
          />
        </div>
      ),
    },
    {
      header: "Lottery Id",
      accessorKey: "_id",
      size: 10,
    },
    {
      header: "Lottery Name",
      accessorKey: "lotteryName",
      size: 10,
    },
    {
      header: "Price",
      accessorKey: "ticketPrice",
      size: 10,
    },
    {
      header: "Tickets on Sale",
      accessorKey: "numOfTicketOnSale",
      size: 10,
    },
    {
      header: "Sold Tickets",
      accessorKey: "numOfTicketSold",
      size: 10,
    },
    {
      header: "Total Draw",
      accessorKey: "totalDraw",
      size: 10,
    },
  ]);

  useEffect(() => {
 
     getData(debouncedSearchText);
   }, [page, limit, debouncedSearchText, location.pathname]);
 
 

    const getData = async (searchText) => {
      setLoading(true);
      const token = localStorage.getItem("token");
      console.log(token);
      await axios
        .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lotterylist`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: { page, limit, search: searchText },
        })
        .then((res) => {
          console.log(res);
          setUsers(res.data);
          setFormValues({
            lotteryName: res.data.data.lotteryName,
            ticketPrice: res.data.data.ticketPrice,
            numOfTicketOnSale: res.data.data.ticketOnSale,
            ticketCountdown: res.data.data.ticketCountdown,
            startDate: res.data.data.startDate,
            endDate: res.data.data.endDate,
            startTime: res.data.data.startTime,
            endTime: res.data.data.endTime,
            lotteryDrawDate: res.data.data.lotteryDrawDate,
            lotteryDrawtime: res.data.data.lotteryDrawTime,
            totalDraw: res.data.data.totalDraw,
            firstDrawPrize: res.data.data.firstDrawPrize,
            secondDrawPrize: res.data.data.secondDrawPrize,
            thirdDrawPrize: res.data.data.thirdDrawPrize,
            instruction: res.data.data.instruction,
            maxRpmLotteryWheel: res.data.data.maxRpmLotteryWheel,
            decelarationOfLotteryWheel: res.data.data.decelarationOfLotteryWheel,
            maxNumOfTickets: res.data.data.maxNumOfTickets,
            status: res.data.data.status,
          });
          setPaginationData({
            currentPage: res.data.pagination.currentPage,
            pageSize: res.data.pagination.pageSize,
            totalPages: res.data.pagination.totalPages,
            totalItems: res.data.pagination.totalRecords,
          });
        })
  
        .catch((err) => {
          console.log(err);
          if (
            err.response.data.message ==
            "For security reasons, we locked your account.Please login to continue"
          ) {
            localStorage.removeItem("token");
            window.location.assign("/auth/login-page");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    };
  const updatePage = (newPage) => {
    setPage(newPage);
  };
  const debouncedSearch = useMemo(() => debounce((value) => {
    setDebouncedSearchText(value);
    if (value === "") {
      setPage(1);
      setLimit(10);
    }
  }, 500), []);
  return (
    <>
      {!isViewing && (
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Winner Logs</h4>

              </CardHeader>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <CardBody>
                  <MantineReactTable
                    columns={columns}
                    positionActionsColumn="first"
                    displayColumnDefOptions={{
                      "mrt-row-actions": {
                        mantineTableHeadCellProps: {
                          align: "center",
                        },
                        size: 120,
                      },
                    }}
                    data={lotteryData || []}
                    enableColumnFilters={false}
                    enableColumnFilterModes={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    enableFullScreenToggle={false}
                    enableDensityToggle={false}
                    enableHiding={false}
                    enableColumnResizing={false}
                    enableColumnOrdering={false}
                    initialState={{ showColumnFilters: true }}
                    positionToolbarAlertBanner="bottom"
                    enablePagination={false}
                    enableEditing
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          flexWrap: "wrap",
                          padding: "16px",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "6px 12px",
                            width: "300px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <i className="material-icons" style={{ color: "#aaa", marginRight: "8px" }}>
                            search
                          </i>
                          <input
                            type="text"
                            value={searchText}
                            placeholder="Search by lottery name or ID"
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              debouncedSearch(e.target.value);
                            }}
                            style={{
                              border: "none",
                              outline: "none",
                              width: "100%",
                              fontSize: "14px",
                            }}
                          />

                        </Box>
                    
                      </Box>
                    )}
                    renderRowActions={({ row }) => (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Tooltip withArrow label="view">
                          <ActionIcon
                            onClick={() =>
                              navigate(
                                `/admin/report-management/WinnerLogs/winnerLogsById?LotteryId=${row.original._id}`
                              )
                            }
                          >
                            <IconEye />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    )}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Pagination
                      pageSize={paginationData?.pageSize}
                      onChange={updatePage}
                      current={paginationData?.currentPage}
                      total={paginationData?.totalItems}
                    />
                  </Box>
                </CardBody>
              )}
            </Card>
          </GridItem>
        </GridContainer>
      )}
      <Outlet />
    </>
  );
}
